import { Link } from "react-router-dom";
import { Home, ArrowLeft, Sparkles } from "lucide-react";
import { getUser } from "@/lib/api";

export default function NotFound() {
  const user = getUser();
  const home = user ? "/dashboard" : "/";
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 md:px-6 overflow-x-hidden"
      style={{
        background:
          "radial-gradient(1200px 500px at 100% -10%, rgba(15,110,86,0.06) 0%, rgba(15,110,86,0) 60%)," +
          "radial-gradient(900px 400px at -10% 20%, rgba(201,168,76,0.06) 0%, rgba(201,168,76,0) 55%)," +
          "linear-gradient(180deg, #fafaf7 0%, #f5f5f1 100%)",
      }}
      data-testid="not-found-page"
    >
      <div className="max-w-lg w-full text-center">
        <div
          className="w-20 h-20 mx-auto rounded-3xl flex items-center justify-center mb-6"
          style={{
            background: "linear-gradient(135deg, #0b3d2e 0%, #0F6E56 100%)",
            boxShadow: "0 12px 30px -10px rgba(11,61,46,0.55)",
          }}
        >
          <Sparkles className="w-9 h-9" style={{ color: "#E5C874" }} strokeWidth={2} />
        </div>
        <div
          className="font-display font-bold mb-3"
          style={{
            fontSize: "clamp(64px, 12vw, 120px)",
            lineHeight: 1,
            background: "linear-gradient(135deg, #0b3d2e 0%, #C9A84C 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            letterSpacing: "-0.05em",
          }}
        >
          404
        </div>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900 mb-2">
          Esta página no existe
        </h1>
        <p className="text-sm md:text-base text-slate-500 mb-8 leading-relaxed max-w-md mx-auto">
          Puede que el enlace esté roto o que la página haya cambiado. Vuelve al inicio y sigue desde tu dashboard.
        </p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Link
            to={home}
            className="rounded-full px-6 py-2.5 text-sm font-semibold text-white inline-flex items-center gap-2 transition-all hover:-translate-y-0.5"
            style={{
              background: "linear-gradient(135deg, #0b3d2e 0%, #14523f 55%, #0F6E56 100%)",
              boxShadow: "0 8px 22px -8px rgba(11,61,46,0.5)",
            }}
            data-testid="not-found-home-btn"
          >
            <Home className="w-4 h-4" strokeWidth={2} /> Volver al inicio
          </Link>
          <button
            onClick={() => window.history.back()}
            className="rounded-full px-6 py-2.5 text-sm font-semibold inline-flex items-center gap-2 transition-all hover:-translate-y-0.5"
            style={{ background: "#ffffff", color: "#0b3d2e", border: "1px solid #e2e8f0" }}
          >
            <ArrowLeft className="w-4 h-4" /> Atrás
          </button>
        </div>
      </div>
    </div>
  );
}
